var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          d:
            "M13.602,9.601 L2.401,9.601 C1.958,9.601 1.6,9.243 1.6,8.801 L1.6,8.39 L14.403,8.39 L14.403,8.801 C14.403,9.243 14.043,9.601 13.602,9.601 M2.401,1.601 L13.602,1.601 C14.043,1.601 14.403,1.959 14.403,2.4 L14.403,6.911 L1.6,6.911 L1.6,2.4 C1.6,1.959 1.958,1.601 2.401,1.601 M2.401,0 C1.075,0 0,1.075 0,2.4 L0,8.801 C0,10.127 1.075,11.202 2.401,11.202 L7.202,11.202 L7.202,13.4008 L4,13.4008 C3.559,13.4008 3.201,13.7588 3.201,14.2008 C3.201,14.6428 3.559,15.0008 4,15.0008 L12.002,15.0008 C12.444,15.0008 12.802,14.6428 12.802,14.2008 C12.802,13.7588 12.444,13.4008 12.002,13.4008 L8.801,13.4008 L8.801,11.202 L13.602,11.202 C14.928,11.202 16.002,10.127 16.002,8.801 L16.002,2.4 C16.002,1.075 14.928,0 13.602,0 L2.401,0 Z",
          id: "display_map"
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "g",
      {
        attrs: {
          id: "Page-1",
          stroke: "none",
          "stroke-width": "1",
          fill: "none",
          "fill-rule": "evenodd"
        }
      },
      [
        _c(
          "g",
          {
            attrs: {
              id: "Desktop-HD2",
              transform: "translate(-350.000000, -270.000000)"
            }
          },
          [
            _c(
              "g",
              {
                attrs: {
                  id: "Group",
                  transform: "translate(350.000000, 270.000000)"
                }
              },
              [
                _c("rect", {
                  staticStyle: { "mix-blend-mode": "color-burn" },
                  attrs: {
                    id: "Rectangle-Copy",
                    "fill-opacity": "0.01",
                    fill: "#E3E3E3",
                    x: "0",
                    y: "0",
                    width: "24",
                    height: "24"
                  }
                }),
                _vm._v(" "),
                _c(
                  "g",
                  {
                    attrs: {
                      id: "colors/branding/secondary",
                      transform: "translate(3.999600, 4.999200)"
                    }
                  },
                  [
                    _c("mask", { attrs: { id: "mask-2", fill: "white" } }, [
                      _c("use", { attrs: { "xlink:href": "#display_map" } })
                    ]),
                    _vm._v(" "),
                    _c("use", {
                      attrs: {
                        id: "Mask",
                        fill: _vm.currentColor,
                        opacity: _vm.opacity,
                        "xlink:href": "#display_map"
                      }
                    })
                  ]
                )
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }